// extracted by mini-css-extract-plugin
export default {"left":"TaskBarWin98_left__sotEY","line":"TaskBarWin98_line__La5NZ"};